import { BackgroundJob, BackgroundJobStatusEnum } from 'graphql-common';

// Gate on the whole tree's rollup (`treeStatus`), not the root's own `status`
// — a root can go Complete while a child (e.g. AI detection) is still live,
// and "clear all" must stay disabled until the entire tree is terminal.
// `treeStatus` already folds Retrying into Working, so those are the only two
// live values to check.
export default function isDeleteAllJobsAvailable(jobs: BackgroundJob[]) {
  return !jobs.some(
    ({ treeStatus }) =>
      treeStatus === BackgroundJobStatusEnum.Queued ||
      treeStatus === BackgroundJobStatusEnum.Working,
  );
}
